import React, { useEffect, useRef, useState } from "react";

// 3rd Party Library
import moment from "moment";
import PropTypes from "prop-types";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { SlCalender } from "react-icons/sl";

// Styles
import "bootstrap-daterangepicker/daterangepicker.css";
import styles from "./daterange-styles.module.scss";

const CustomDateRangePicker = (props) => {
  const [startDate, setStartDate] = useState(props?.initialSettings?.startDate);
  const [endDate, setEndDate] = useState(props?.initialSettings?.endDate);
  const [formattedDateRange, setFormattedDateRange] = useState("");
  const [haserror, setHaserror] = useState(false);
  const [pickerKey, setPickerKey] = useState(0);
  const pickerRef = useRef(null);

  const handleApply = (event, picker) => {
    setStartDate(picker.startDate._d);
    setEndDate(picker.endDate._d);
    props.selectedDate({
      startDate: picker.startDate._d.toISOString(),
      endDate: picker.endDate._d.toISOString(),
    });
  };
  const handleKeyPress = (event) => {
    const keyCode = event.which;
    const input = event.target;
    let inputValue = input.value;

    const monthRegExp = /^(0[1-9]|1[0-2])$/;
    const dateRegExp = /^(0[1-9]|[12][0-9]|3[01])$/;
    const yearRegExp = /^\d{4}$/;

    if (keyCode < 48 || keyCode > 57) {
      event.preventDefault();
      return;
    }

    if (inputValue.length >= 23) {
      event.preventDefault();
      return;
    }

    if (inputValue.length === 2 && keyCode !== 47) {
      if (!monthRegExp.test(inputValue)) {
        props.errorHandler(true, "Invalid Month format");
        setHaserror(true);
        event.preventDefault();
        return;
      } else {
        setHaserror(false);
        props.errorHandler(false, "");
      }
      inputValue = inputValue + "/";
    } else if (inputValue.length === 5 && keyCode !== 47) {
      if (!dateRegExp.test(inputValue.slice(3, 5))) {
        props.errorHandler(true, "Invalid Date format");
        setHaserror(true);
        event.preventDefault();
        return;
      } else {
        setHaserror(false);
        props.errorHandler(false, "");
      }
      inputValue = inputValue + "/";
    } else if (inputValue.length === 10 && keyCode !== 45) {
      if (!yearRegExp.test(inputValue.slice(6, 10))) {
        props.errorHandler(true, "Invalid Year format");
        setHaserror(true);
        event.preventDefault();
        return;
      } else {
        setHaserror(false);
        props.errorHandler(false, "");
      }
      inputValue = inputValue + " - ";
    } else if (inputValue.length === 15 && keyCode !== 47) {
      if (!monthRegExp.test(inputValue.slice(13, 15))) {
        props.errorHandler(true, "Invalid Month format");
        setHaserror(true);
        event.preventDefault();
        return;
      } else {
        setHaserror(false);
        props.errorHandler(false, "");
      }
      inputValue = inputValue + "/";
    } else if (inputValue.length === 18 && keyCode !== 47) {
      if (!dateRegExp.test(inputValue.slice(16, 18))) {
        setHaserror(true);
        props.errorHandler(true, "Invalid Date format");
        event.preventDefault();
        return;
      } else {
        setHaserror(false);
        props.errorHandler(false, "");
      }
      inputValue = inputValue + "/";
    }

    input.value = inputValue;
  };
  useEffect(() => {
    const formatDateString = (date) => {
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      const month =
        date.getMonth() + 1 < 10
          ? `0${date.getMonth() + 1}`
          : date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const formattedStartDate = startDate
      ? formatDateString(new Date(startDate))
      : props?.initialSettings?.startDate;
    const formattedEndDate = endDate
      ? formatDateString(new Date(endDate))
      : props?.initialSettings?.endDate;
    const newFormattedDateRange = `${formattedStartDate} - ${formattedEndDate}`;
    setFormattedDateRange(newFormattedDateRange);
  }, [
    startDate,
    endDate,
    props?.initialSettings?.startDate,
    props?.initialSettings?.endDate,
  ]);

  // Add this useEffect to handle external date changes
  useEffect(() => {
    if (props?.initialSettings?.startDate && props?.initialSettings?.endDate) {
      setStartDate(props.initialSettings.startDate);
      setEndDate(props.initialSettings.endDate);
      setPickerKey((prev) => prev + 1); // Force re-render when dates change
    }
  }, [props.initialSettings]);

  return (
    <DateRangePicker
      key={`datepicker-${pickerKey}`}
      ref={pickerRef}
      {...props}
      alwaysShowCalendars={false}
      onApply={handleApply}
      initialSettings={{
        ...props.initialSettings,
        startDate: moment(startDate),
        endDate: moment(endDate),
      }}
    >
      <div
        style={
          props?.showIcon
            ? { position: "relative", display: "inline-block" }
            : {}
        }
      >
        <span>
          <input
            type="text"
            className={`form-control${haserror ? styles.dateError : ""} ${
              props?.className || ""
            }`}
            placeholder={"Start Date/End Date"}
            onKeyPress={props.dateOnly === "true" ? handleKeyPress : null}
            value={formattedDateRange}
          />
          {props?.showIcon && <SlCalender className={styles.obsDateFltrIcon} />}
        </span>
      </div>
    </DateRangePicker>
  );
};

export default React.memo(CustomDateRangePicker);
CustomDateRangePicker.propTypes = {
  initialSettings: PropTypes.shape({
    startDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]),
    endDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]),
  }),
  selectedDate: PropTypes.func.isRequired,
  errorHandler: PropTypes.func,
  showIcon: PropTypes.bool,
  className: PropTypes.string,
  dateOnly: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};



